import { render, staticRenderFns } from "./ventas.vue?vue&type=template&id=429a1f90"
import script from "./ventas.vue?vue&type=script&lang=js"
export * from "./ventas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports